/* eslint-disable */
import stripIndent from '../../Vendor/strip-indent';

/**
 * Thrown when `refreshAccessToken()` is called when no user is currently logged in
 * @export
 * @class AuthCouldNotRefreshAccessTokenWhilstNotLoggedInError
 * @extends {Error}
 */
export class AuthCouldNotRefreshAccessTokenWhilstNotLoggedInError extends Error {
  /**
   * Creates an instance of AuthCouldNotRefreshAccessTokenWhilstNotLoggedInError
   * @param {string} message The Error `message`
   * @memberof AuthCouldNotRefreshAccessTokenWhilstNotLoggedInError
   */
  constructor(message) {
    super(message);
    this.name = `AuthCouldNotRefreshAccessTokenWhilstNotLoggedInError`;
  }
}

/**
 * Called when `refreshAccessToken()` is called when no user is currently logged in
 * @returns {never} never
 */
const throwAuthCouldNotRefreshAccessTokenWhilstNotLoggedInError = () => {
  throw new AuthCouldNotRefreshAccessTokenWhilstNotLoggedInError(
    stripIndent(`
    Could not refresh access token when no user is currently logged in.
    `),
  );
};

export default throwAuthCouldNotRefreshAccessTokenWhilstNotLoggedInError;
